import React from 'react';
import { colors, fonts } from './styles';
import { Highlight } from './Highlight';

const meetingLink = process.env.REACT_APP_HUBSPOT_MEETING_LINK
  || 'mailto:sbd@realpatients.com?subject=Pulse%20Checks%20%E2%80%93%20Discovery%20Call';

export const ContactSection = () => {
  const [hoverPrimary, setHoverPrimary] = React.useState(false);
  const [hoverSecondary, setHoverSecondary] = React.useState(false);
  const isExternal = meetingLink.startsWith('http');

  return (
    <section
      id="contact"
      style={{
        backgroundColor: colors.offWhite,
        textAlign: 'center',
        padding: '120px 48px',
        boxSizing: 'border-box',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <style>{`
        @media (max-width: 768px) {
          .pi-cta { padding-left: 24px !important; padding-right: 24px !important; padding-top: 80px !important; padding-bottom: 80px !important; }
        }
      `}</style>
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          top: '-150px',
          left: '50%',
          transform: 'translateX(-50%)',
          width: '700px',
          height: '500px',
          background:
            'radial-gradient(ellipse, rgba(235,160,155,0.2) 0%, rgba(245,215,170,0.14) 40%, transparent 70%)',
          pointerEvents: 'none',
        }}
      />
      <div className="pi-cta" style={{ maxWidth: '640px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <h2
          style={{
            fontFamily: fonts.serif,
            fontSize: 'clamp(30px, 4vw, 52px)',
            fontWeight: 700,
            color: colors.charcoal,
            lineHeight: 1.1,
            margin: '0 0 20px',
          }}
        >
          Tell us what your
          <br />
          <span style={{ fontStyle: 'italic', fontWeight: 400 }}>
            team needs to <Highlight>know</Highlight>.
          </span>
        </h2>
        <p
          style={{
            fontFamily: fonts.sans,
            fontSize: '17px',
            color: colors.warmGray,
            margin: '0 0 48px',
            fontWeight: 400,
            lineHeight: 1.65,
          }}
        >
          We'll show you how a Pulse Check<sup style={{ fontSize: '0.6em', verticalAlign: 'super' }}>TM</sup> would work for your specific question — and what intelligence you could have back before your next meeting.
        </p>

        <div
          style={{
            display: 'flex',
            gap: '16px',
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}
        >
          <a
            href={meetingLink}
            target={isExternal ? '_blank' : undefined}
            rel={isExternal ? 'noopener noreferrer' : undefined}
            onMouseEnter={() => setHoverPrimary(true)}
            onMouseLeave={() => setHoverPrimary(false)}
            style={{
              backgroundColor: hoverPrimary ? '#2F5C60' : colors.deepTeal,
              color: colors.white,
              fontFamily: fonts.sans,
              fontSize: '15px',
              fontWeight: 600,
              padding: '16px 32px',
              borderRadius: '8px',
              textDecoration: 'none',
              transition: 'background-color 0.2s ease, transform 0.15s ease, box-shadow 0.2s ease',
              display: 'inline-block',
              transform: hoverPrimary ? 'translateY(-1px)' : 'translateY(0)',
              boxShadow: hoverPrimary ? '0 6px 20px rgba(61,116,120,0.35)' : '0 4px 16px rgba(61,116,120,0.25)',
            }}
          >
            Book a discovery call
          </a>
          <a
            href="mailto:sbd@realpatients.com"
            onMouseEnter={() => setHoverSecondary(true)}
            onMouseLeave={() => setHoverSecondary(false)}
            style={{
              backgroundColor: hoverSecondary ? 'rgba(39,39,38,0.04)' : 'transparent',
              color: colors.charcoal,
              fontFamily: fonts.sans,
              fontSize: '15px',
              fontWeight: 500,
              padding: '16px 32px',
              borderRadius: '8px',
              textDecoration: 'none',
              border: `1.5px solid ${hoverSecondary ? colors.charcoal : colors.border}`,
              display: 'inline-block',
              transition: 'border-color 0.2s ease, background-color 0.2s ease',
            }}
          >
            sbd@realpatients.com
          </a>
        </div>

      </div>
    </section>
  );
};
